var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11542_2155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7742 18C21.5235 18 22.1195 17.5285 22.6546 16.8691C23.75 15.5194 21.9514 14.4408 21.2655 13.9126C20.5681 13.3756 19.7895 13.0714 19.0001 13M18.0001 11C19.3808 11 20.5001 9.88071 20.5001 8.5C20.5001 7.11929 19.3808 6 18.0001 6M3.22609 18C2.47679 18 1.8808 17.5285 1.34568 16.8691C0.250226 15.5194 2.04881 14.4408 2.73478 13.9126C3.43211 13.3756 4.21072 13.0714 5.00014 13M5.50014 11C4.11943 11 3.00014 9.88071 3.00014 8.5C3.00014 7.11929 4.11943 6 5.50014 6M8.08391 15.1112C10.48 13.6296 13.5202 13.6296 15.9163 15.1112C16.9381 15.743 19.6171 17.0331 17.9854 18.6474C17.1883 19.436 16.3006 20 15.1845 20H8.81573C7.69962 20 6.81188 19.436 6.0148 18.6474C4.38309 17.0331 7.06213 15.743 8.08391 15.1112ZM15.5001 7.5C15.5001 9.433 13.9331 11 12.0001 11C10.0671 11 8.5001 9.433 8.5001 7.5C8.5001 5.567 10.0671 4 12.0001 4C13.9331 4 15.5001 5.567 15.5001 7.5Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11542_2155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.7f9363d05d7af882c13eba11f947acbd.svg";
export { ForwardRef as ReactComponent };